import { defineStore } from 'pinia'

const useStaticSitemapEntriesStore = defineStore('staticSitemapEntries', {
  state: () => ({}),
  actions: {},
})

export default useStaticSitemapEntriesStore
